/**
 * This reducer is used for storing PaymentData
 */
import { SET_PAYMENT_DETAILS } from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const initialState = {
    paymentData: [],
};

const paymentDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PAYMENT_DETAILS:
            return {
                ...state,
                paymentData: action.payload,
            };

        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'paymentDataKey',
        storage: storage,
    },
    paymentDataReducer
);
